import { Pagination } from '../../../model/paginatiion';
import { IGovernmentProjectResponse } from '../../../model/base/response/government-project-response';

export type GovernmentProjectsState = {
    projects: Pagination<IGovernmentProjectResponse>;
    loading: boolean;
};

export enum ACTION_TYPES {
    setProjects = 'setProjects',
    setLoading = 'setLoading',
}

export const GovernmentProjectsReducer = (state: GovernmentProjectsState, action: any): GovernmentProjectsState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setProjects:
            return {
                ...state,
                projects: payload,
                loading: false,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
